import React, { useState, useEffect, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import { Recs } from '../../components/Recs';
import BeautyButton from '../../components/BeautyButton';
import ProductSearch from '../../components/ProductSearch'
import ImportProductInput from '../../components/ImportProductInput'
import debounce from 'lodash.debounce';

const SkinPassportPage = () => {

  const [searchLookup, setSearchLookup] = useState({});

  // Products - State and Logic, now using a consistent object format
  const [selectedFavoriteProducts, setSelectedFavoriteProducts] = useState([
    // { id: 'prod-a', name: 'Product A' },
    // { id: 'prod-b', name: 'Product B' }
  ]);
  const [selectedWorstProducts, setSelectedWorstProducts] = useState([
    // { id: 'prod-c', name: 'Product C' },
    // { id: 'prod-d', name: 'Product D' }
  ]);

  const handleDragEnd = (result) => {
    const { source, destination, draggableId } = result;

    if (!destination) return;

    // Logic for dragging from search results
    if (source.droppableId === "searchResults") {
      const movedProduct = searchLookup[draggableId];
      if (!movedProduct) return;

      if (destination.droppableId === "favorites") {
        const isDuplicate = selectedFavoriteProducts.some(p => p.id === movedProduct.id);
        if (!isDuplicate) {
          setSelectedFavoriteProducts([...selectedFavoriteProducts, movedProduct]);
        }
      } else if (destination.droppableId === "worst") {
        const isDuplicate = selectedWorstProducts.some(p => p.id === movedProduct.id);
        if (!isDuplicate) {
          setSelectedWorstProducts([...selectedWorstProducts, movedProduct]);
        }
      }
      return;
    }

    // Logic for reordering/moving between favorites and worst lists
    let fav = Array.from(selectedFavoriteProducts);
    let worst = Array.from(selectedWorstProducts);

    const isFav = source.droppableId === "favorites";
    const sourceList = isFav ? fav : worst;
    const destList = destination.droppableId === "favorites" ? fav : worst;

    const [moved] = sourceList.splice(source.index, 1);
    destList.splice(destination.index, 0, moved);

    setSelectedFavoriteProducts(fav);
    setSelectedWorstProducts(worst);
  };

  const handleRemoveFavoriteProduct = (productToRemove) => {
    setSelectedFavoriteProducts(selectedFavoriteProducts.filter(product => product.id !== productToRemove.id));
  };

  const handleRemoveWorstProduct = (productToRemove) => {
    setSelectedWorstProducts(selectedWorstProducts.filter(product => product.id !== productToRemove.id));
  };

  const createProductSlug = (productName) => {
    return productName.replace(/\s+/g, '-').toLowerCase();
  };
  
  // Remaining code from your original component (Ingredients, etc.) is unchanged
  const allFavoriteIngredients = [
    'Hyaluronic Acid', 'Vitamin C', 'Vitamin E', 'Retinol', 'Niacinamide', 'Ceramides',
    'Peptides', 'Aloe Vera', 'Green Tea Extract',
  ];
  const allAllergicIngredients = [
    'Fragrance', 'Sulfates', 'Parabens', 'Alcohol denat.', 'Silicones',
  ];
  const allUnfavorableIngredients = [
    'Mineral Oil', 'Petrolatum', 'Drying Alcohols (Ethanol, Isopropyl Alcohol)', 'Synthetic Dyes',
  ];
  const [selectedFavoriteIngredients, setSelectedFavoriteIngredients] = useState(['Hyaluronic Acid', 'Vitamin E', 'Aloe Vera']);
  const [selectedAllergicIngredients, setSelectedAllergicIngredients] = useState(['Ingredient X', 'Ingredient Y']);
  const [selectedUnfavorableIngredients, setSelectedUnfavorableIngredients] = useState([]);
  const toggleFavoriteIngredient = (ingredient) => {
    if (selectedFavoriteIngredients.includes(ingredient)) {
      setSelectedFavoriteIngredients(selectedFavoriteIngredients.filter((item) => item !== ingredient));
    } else {
      setSelectedFavoriteIngredients([...selectedFavoriteIngredients, ingredient]);
    }
  };
  const toggleAllergicIngredient = (ingredient) => {
    if (selectedAllergicIngredients.includes(ingredient)) {
      setSelectedAllergicIngredients(selectedAllergicIngredients.filter((item) => item !== ingredient));
    } else {
      setSelectedAllergicIngredients([...selectedAllergicIngredients, ingredient]);
    }
  };
  const toggleUnfavorableIngredient = (ingredient) => {
    if (selectedUnfavorableIngredients.includes(ingredient)) {
      setSelectedUnfavorableIngredients(selectedUnfavorableIngredients.filter((item) => item !== ingredient));
    } else {
      setSelectedUnfavorableIngredients([...selectedUnfavorableIngredients, ingredient]);
    }
  };
  const bgNotSelected = '#CAC5D4'
  const notSelectedBorder = '#CAC5D4'
  const notSelectedText = '#EDEAF4'
  const getButtonStyles = (ingredient, category) => {
    switch (category) {
      case "favorite":
        return selectedFavoriteIngredients.includes(ingredient)
          ? { className: "bg-[#A8C7AD] text-[#1E627D] border-[#1E627D]" }
          : { style: { backgroundColor: bgNotSelected, borderColor: notSelectedBorder, color: notSelectedText } };
      case "unfavorable":
        return selectedUnfavorableIngredients.includes(ingredient)
          ? { className: "bg-[#FBD899] text-[#9A7022] border-[#9A7022]" }
          : { className: "hover:bg-[#C58348]", style: { backgroundColor: bgNotSelected, borderColor: notSelectedBorder, color: notSelectedText } };
      case "allergic":
        return selectedAllergicIngredients.includes(ingredient)
          ? { className: "bg-[#F6B6E2] text-[#7D1E5F] border-[#7D1E5F]" }
          : { className: "hover:bg-[#C58348]", style: { backgroundColor: bgNotSelected, borderColor: notSelectedBorder, color: notSelectedText } };
      default:
        return { className: "" };
    }
  };

  return (
    <div className="bg-[#A89B8D] flex flex-col min-h-screen">
      <Header />
      <main className=" flex-grow container mx-auto px-4 py-8">


      <div className="mb-10 w-full rounded-3xl bg-gradient-to-r from-[#E9A969] to-[#EDEAF4] shadow-xl overflow-hidden">
  <div className="flex flex-col sm:flex-row justify-between items-center gap-10 px-10 py-14">

    {/* Left Side - Hero Content */}
    <div className="flex-1 space-y-6 order-1 sm:order-1">
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#5F40A1] drop-shadow-sm">
        Your Personalized <br />Skin Passport
      </h1>
      <p className="text-gray-700 text-lg sm:text-xl leading-relaxed max-w-xl">
        Skin Passport is your complete skincare profile, designed to improve hydration, brightness, and combat signs of aging like forehead lines, crow’s feet, and sagging jawlines. Get tailored recommendations for overall skin health and discover products perfectly suited to your unique profile.
      </p>
      <button
        onClick={() => {
          document.getElementById("products-table")?.scrollIntoView({
            behavior: "smooth",
          });
        }}
        className="group relative inline-flex items-center justify-center overflow-hidden rounded-full bg-[#5F40A1] px-8 py-3 text-white font-medium transition-all hover:bg-[#4A2F82] shadow-md hover:shadow-lg"
      >
        <span className="absolute inset-0 h-full w-full bg-gradient-to-r from-[#7A5CCF] to-[#5F40A1] opacity-0 transition-opacity duration-300 group-hover:opacity-100"></span>
        <span className="relative">Discover Your Skin Passport</span>
      </button>
    </div>

    {/* Right Side - Stats */}
    <div className="flex flex-col sm:flex-row flex-1 justify-evenly sm:justify-center sm:gap-16 order-2 sm:order-2 w-full space-y-6 sm:space-y-0">
      {[
        { label: "Skin Concerns Tracked", value: "12+" },
        { label: "Recommended Products", value: "100s+" },
        { label: "Ingredients Monitored", value: "500+" },
      ].map((stat, i) => (
        <div
          key={i}
          className="flex flex-col items-center bg-white/60 backdrop-blur-md px-6 py-6 rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-1 w-full sm:w-auto"
        >
          <span className="text-4xl font-extrabold text-[#5F40A1]">{stat.value}</span>
          <span className="text-gray-600 text-sm mt-1">{stat.label}</span>
        </div>
      ))}
    </div>

  </div>
</div>

       


        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="gap-8">
            <Recs />
          </div>

          <div className="grid gap-6">
            <div className="bg-[#EDEAF4] p-6 rounded-md">
              <div className="mb-6">
                <BeautyButton text="favorite ingredients" type="popup" showCloseButton={false} />
                <div className="mt-4 flex flex-wrap gap-2">
                  {allFavoriteIngredients.map((ingredient) => {
                    const styles = getButtonStyles(ingredient, "favorite");
                    return (
                      <button
                        key={ingredient}
                        className={` px-4 py-2 border rounded-full text-sm font-medium transition-colors ${styles.className} `}
                        style={styles.style}
                        onClick={() => toggleFavoriteIngredient(ingredient)}
                      >
                        {ingredient}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className="mb-6">
                <BeautyButton text="unfavorable ingredients" type="popup" showCloseButton={false} />
                <div className="mt-4 flex flex-wrap gap-2">
                  {allUnfavorableIngredients.map((ingredient) => {
                    const styles = getButtonStyles(ingredient, "unfavorable");
                    return (
                      <button
                        key={ingredient}
                        className={`px-4 py-2 border rounded-full text-sm font-medium transition-colors ${styles.className}`}
                        style={styles.style}
                        onClick={() => toggleUnfavorableIngredient(ingredient)}
                      >
                        {ingredient}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div>
                <BeautyButton text="allergic ingredients" type="popup" showCloseButton={false} />
                <div className="mt-4 flex flex-wrap gap-2">
                  {allAllergicIngredients.map((ingredient) => {
                    const styles = getButtonStyles(ingredient, "allergic");
                    return (
                      <button
                        key={ingredient}
                        className={`px-4 py-2 border rounded-full text-sm font-medium transition-colors ${styles.className}`}
                        style={styles.style}
                        onClick={() => toggleAllergicIngredient(ingredient)}
                      >
                        {ingredient}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
            </div>

            <div className="bg-[#EDEAF4] p-6 rounded-md gap-2">
              <h3 className="text-xl font-semibold mb-4">Products</h3>
              <DragDropContext onDragEnd={handleDragEnd}>
                <div className="mb-6">
                  {/* Product Search */}
                  <BeautyButton
                    text="search"
                    type="popup"
                    iconType="info"
                    description="Find products in our database and drag them directly into your Cosmobag."
                  />
                  <div id="search-contents" className="mt-6 bg-[#CDC7DD] rounded-lg shadow-sm">
                    {/* The ProductSearch component now handles its own state */}
                    <ProductSearch setSearchLookup={setSearchLookup} />
                  </div>

                  <BeautyButton
                    text="import"
                    type="popup"
                    iconType="import"
                    description="Paste a product link from Amazon or other supported stores to import it into your Cosmobag. Our team will review the product and add it to the database if it meets our website criteria."
                  />
                  <div className="mt-6 mb-6 bg-[#E9A969] rounded-lg p-4 shadow-sm">
                    <ImportProductInput handleSectionChange={() => {}} />
                  </div>
                </div>

                {/* Favorite Products */}
                {/* <h4 className="font-semibold text-lg mb-2">Favorite Products</h4> */}
                <BeautyButton
                    text="favorite products"
                    type="popup"
                    iconType="import"
                    description="This section is your personal 'hall of fame' for skincare. It's where you keep a record of all the products you've tried and loved. Drag products into this list to mark them as a favorite, and our recommendations engine will learn what your skin responds to. This helps us find similar products and ingredients that you're likely to enjoy."
                  />
                <Droppable droppableId="favorites" direction="vertical">
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="space-y-2 mb-6 min-h-[80px] border border-dashed border-green-400 p-2 rounded bg-green-50"
                    >
                      {selectedFavoriteProducts.map((product, index) => (
                        <Draggable key={`fav-${product.id}`} draggableId={`fav-${product.id}`} index={index}>
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className="flex items-center justify-between bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full shadow-sm"
                            >
                              <Link to={`/products/${createProductSlug(product.name)}`} className="mr-1 underline">
                                {product.name}
                              </Link>
                              <button
                                className="ml-1 text-green-800 hover:text-green-900"
                                onClick={() => handleRemoveFavoriteProduct(product)}
                              >
                                <Icon name="X" size={12} />
                              </button>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>

                {/* Worst Products */}
                {/* <h4 className="font-semibold text-lg mb-2">Worst Products</h4> */}
                <BeautyButton
                    text="worst products"
                    type="popup"
                    iconType="import"
                    description="This list is for products that caused an undesirable reaction, didn't meet your expectations, or simply weren't a good fit. By adding a product here, you teach our recommendation system what to avoid. It's a key step to preventing future breakouts or allergic reactions and helps us find products with ingredients and formulations that are more compatible with your skin."
                  />


                <Droppable droppableId="worst" direction="vertical">
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="space-y-2 min-h-[80px] border border-dashed border-red-400 p-2 rounded bg-red-50"
                    >
                      {selectedWorstProducts.map((product, index) => (
                        <Draggable key={`worst-${product.id}`} draggableId={`worst-${product.id}`} index={index}>
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className="flex items-center justify-between bg-red-100 text-red-800 text-sm font-medium px-3 py-1 rounded-full shadow-sm"
                            >
                              <Link to={`/products/${createProductSlug(product.name)}`} className="mr-1 underline">
                                {product.name}
                              </Link>
                              <button
                                className="ml-1 text-red-800 hover:text-red-900"
                                onClick={() => handleRemoveWorstProduct(product)}
                              >
                                <Icon name="X" size={12} />
                              </button>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          {/* </div> */}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SkinPassportPage;